import script from "./ReserveSpotsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReserveSpotsModal.vue?vue&type=script&setup=true&lang=js"

import "./ReserveSpotsModal.vue?vue&type=style&index=0&id=410529ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410529ca"]])

export default __exports__